/**
 * Settings module translations - Pages section
 */

const pages = {
  title: "Configuración",
  productCodes: "Códigos de producto"
};

export default pages;
